import React, { useContext, useState } from "react";
import { Row, Button } from "antd";
import { MessageOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";

import phoneIcon from "../../assets/Phone.svg";
import whatsAppIcon from "../../assets/whatsapp.svg";

import { ModalContext } from "../../context/ModalContext";

import RegisterForm from "./RegisterForm";

import { ModalOverlay } from "../Modal/Modal";
import { getWhatsappMessage } from "../../utils";

import useMapData from "../../utils/useMapData";

const PreRegisterSection = () => {
  const PhoneIcon = () => <img src={phoneIcon} alt="" />;
  const WhatsAppIcon = () => <img width={18} src={whatsAppIcon} alt="" />;

  const { isModalVisible, handleModalVisibility } = useContext(ModalContext);

  const [organizeVisit, setOrganizeVisit] = useState(false);
  const [enquire, setEnquire] = useState(false);

  const { propertyId } = useParams();
  const resultList = useMapData(propertyId);

  const toggleOrganizeVisit = () => {
    setOrganizeVisit(prevState => !prevState);
    handleModalVisibility();
  };

  const toggleEnquire = () => {
    setEnquire(prevState => !prevState);
    handleModalVisibility();
  };

  return (
    <>
      <Row justify="center" align="middle" className="service_info">
        <div className="request_call">
          <Button id="request_call_left_btn" onClick={toggleOrganizeVisit}>
            Organize Site Visit
          </Button>
          <a
            href={getWhatsappMessage(resultList)}
            target="_blank"
            rel="noreferrer"
          >
            <Button icon={<WhatsAppIcon />} id="request_call_right_btn">
              {resultList.phonenumber}
            </Button>
          </a>
        </div>
        <Button
          icon={<PhoneIcon />}
          style={{ background: resultList.themeColor }}
          id="request_call_action_btn"
          onClick={handleModalVisibility}
        >
          Request Call Back
        </Button>
      </Row>
      <div className="mobile_user_action_bottomNav">
        <a
          href={`tel:${resultList.phonenumber}`}
          target="_blank"
          rel="noreferrer"
        >
          <Button
            icon={<PhoneIcon />}
            style={{
              width: "100%",
              background: resultList.themeColor,
            }}
            id="bottomNav_btn"
          >
            Call
          </Button>
        </a>
        <Button
          icon={<MessageOutlined />}
          onClick={toggleEnquire}
          style={{
            width: "100%",
            background: resultList.themeColor,
          }}
          id="bottomNav_btn"
        >
          Enquire
        </Button>
        <a
          href={getWhatsappMessage(resultList)}
          target="_blank"
          rel="noreferrer"
        >
          <Button
            icon={<WhatsAppIcon />}
            style={{
              width: "100%",
              background: resultList.themeColor,
            }}
            id="bottomNav_btn"
          >
            WhatsApp
          </Button>
        </a>
      </div>
      <RegisterForm handleModalVisibility={handleModalVisibility} />
      {isModalVisible && (
        <ModalOverlay
          isModalVisible={isModalVisible}
          handleModalVisibility={handleModalVisibility}
          title={"Immediate Call Back"}
          btnText="Request Call Now"
          actionType="request-call"
        />
      )}
      {organizeVisit && (
        <ModalOverlay
          isModalVisible={organizeVisit}
          handleModalVisibility={toggleOrganizeVisit}
          title={"Organize Site Visit"}
          btnText="Request Site Visit"
          actionType="request-site-visit"
        />
      )}

      {enquire && (
        <ModalOverlay
          isModalVisible={enquire}
          handleModalVisibility={toggleEnquire}
          title="Mail me pricing details"
          btnText="Send Now"
          actionType="mail-costing-details"
        />
      )}
    </>
  );
};

export default PreRegisterSection;
